/**
 * بخش «ژومنت Ads» (خدمات تبلیغاتی ژومنت ادز).
 *
 * مثل سلر آکادمی کاملا از پنل می‌آید:
 *  - خانه: صفحه‌ی `custom_page` با `seo.key = ads-home` که فقط ویجت دارد؛
 *  - هر خدمت: مقاله‌ی `BlogModel` با نوع ۲۰۰۶ (آدرس `/ads/:slug`)؛
 *  - هر هدف: کالکشنِ `CollectionModel` با نوع ۲۰۰۶ از مقاله‌های ۲۰۰۶ (آدرس `/ads/goals/:slug`).
 *
 * نوع‌ها در پنل: سایت‌ها و دسترسی‌ها ← دامنه‌ها ← انواع مدل‌ها (ژومنت ادز / کالکشن‌های ژومنت ادز).
 */

export const ADS_BASE = "/ads";
export const ADS_HOME_HREF = `${ADS_BASE}/`;
export const ADS_SERVICES_HREF = `${ADS_BASE}/services/`;
export const ADS_CONTACT_HREF = "/contact-us/";
export const ADS_FAQ_ID = "ads-faq";
export const ADS_FAQ_HREF = `${ADS_HOME_HREF}#${ADS_FAQ_ID}`;

/** نوع مقاله‌ی خدمت و کالکشن هدف در پنل */
export const ADS_MODEL_TYPE = 2006;
/** `seo.key` صفحه‌ی خانه‌ی ادز (در /sm/blog-seo-keys/management ست می‌شود) */
export const ADS_HOME_SEO_KEY = "ads-home";
/** `seo.key` صفحه‌ی لیست خدمات موبایل */
export const ADS_SERVICES_SEO_KEY = "ads-services";
/** کلید منوی خدمات هدر (از پنل: منوها) */
export const ADS_MENU_KEY = "header-main-menu-ads";

const strip_slashes = (path = "") => path.split("?")[0].replace(/^\/+|\/+$/g, "");

const safe_decode = (value = "") => {
	try {
		return decodeURIComponent(value);
	} catch {
		return value;
	}
};

export const is_ads_path = (pathname = "") => {
	const clean = safe_decode(strip_slashes(pathname));
	return clean === ADS_BASE.slice(1) || clean.startsWith(`${ADS_BASE.slice(1)}/`);
};


/**
 * دکمه‌ی «خدمات تبلیغاتی» نویگیشن پایین موبایل لیست خدمات را در یک مودال تمام‌صفحه (بین هدر و
 * نویگیشن) باز می‌کند؛ مثل دسته‌بندی مجله. state مودال داخل هدر است و ارتباط با رویداد window.
 */
export const ADS_SERVICES_TOGGLE_EVENT = "jmt:ads-services-toggle";
export const ADS_SERVICES_CHANGE_EVENT = "jmt:ads-services-change";
